export default {
  "fbAppName": "philosite",
  "apiVersion": "v2.8",
  "appID": "1104491019696557",
  "appSecret": "3410fbc8bb69db2eaaafea6b61b91b4b",
  "pageID": "487543104589300",
  "accessToken": "EAAPsh1riZBa0BAELR0u2zEsJZBGww0gi33YpotWV1z81MN3HUskYAoc3ZCxSzVqieSxtIJPgQHIe5ZC6AgZADCJLCsGPKYRLfON8GFkwkMsQXPX2TWCbS2RISk4lWKZCiSswcV8TZCZBZBFCshxZAziQfQOmLHAZBZCZAZBNDHqCZCuuJppZAwZDZD"
}
